<template>
  <v-card class="card">
    <v-card-text class="pa-3">
      <line-chart :data="data.h" xtitle="Last 24h" ytitle="Blocked" :dataset="{borderWidth: 3}"/> {{data.all}}
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      data: {}
    }
  },



  created () {
      this.initialize()
    },
   methods: {
        initialize () {
         if(localStorage.getItem('access_token')!=null){ this.$http.defaults.headers.common['X-Authorization'] =  localStorage.getItem('access_token');}

          this.$http
              .get(this.$root.apiUrl+'/api/v1/statistic/bl_last_day')
              .then(r => {
                // console.log('r: ', JSON.stringify(r, null, 2));
                if(r.status === 200){
                  this.data = r.data;
                }

      });
     }
   }

}
</script>

<style>
  .card {
    border-radius: 3px;
    background-clip: border-box;
    border: 1px solid rgba(0, 0, 0, 0.125);
    box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.21);
    background-color: transparent;
  }
</style>



// WEBPACK FOOTER //
// src/components/statistics/SiteViewStatistic.vue